import { AGENCY_NAV_ITEMS, AGENCY_ROUTES, NAV_ITEMS } from "fixtures/constants";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "store";
import { selectPostStore } from "store/posts/postSlice";
import { currentBusinessGetter, selectUserInfo } from "store/user/userSlice";

const useHeaderData = () => {
  const { pathname } = useLocation();
  const { scheduled } = useAppSelector(selectPostStore);
  const user = useAppSelector(selectUserInfo);
  const currentBusiness = useAppSelector(currentBusinessGetter);

  const isBusinessDashboardPage = useMemo(
    () => AGENCY_ROUTES.includes(pathname),
    [pathname]
  );

  const { pageTitle, pageSubtitle } = useMemo(() => {
    if (["/manage-account", "/proxy"].includes(pathname)) {
      return {
        pageTitle: "Manage Account",
        pageSubtitle: "Update your account details",
      };
    }

    const items = isBusinessDashboardPage ? AGENCY_NAV_ITEMS : NAV_ITEMS;
    const currentPageItem = items.find((item) => item.pathname === pathname);

    return {
      pageTitle: currentPageItem?.title,
      pageSubtitle: currentPageItem?.subtitle,
    };
  }, [pathname, isBusinessDashboardPage]);

  return {
    pathname,
    scheduled,
    user,
    currentBusiness,
    isBusinessDashboardPage,
    pageTitle,
    pageSubtitle,
  };
};

export default useHeaderData;
